import React from 'react';
import { Body, Modal } from '@icarros/ids-react';

import { pushSellerPFDashboardEvent } from '../../../../../utils/pushToDataLayer';
import { ModalBody } from './style';

interface MakePaymentModalProps {
  modalOpen: boolean;
  setModalOpen(value: boolean): void;
  paymentUrl: string;
}

export function MakePayment({
  modalOpen,
  setModalOpen,
  paymentUrl
}: MakePaymentModalProps): JSX.Element {
  return (
    <Modal
      stateOpen={[
        modalOpen,
        () => {
          pushSellerPFDashboardEvent('fechar', 'modal fazer o pagamento');
          setModalOpen(false);
        }
      ]}
      body={
        <ModalBody>
          <Body size="body_2" contrast="default" weight="regular" variant="base">
            Pagamentos por boleto podem demorar até 2 dias úteis para serem compensados. Se você já
            fez o pagamento, aguarde pelo prazo indicado.
          </Body>
          <Body size="body_2" contrast="default" weight="regular" variant="base">
            Caso ainda não tenha pago, você pode gerar uma 2ª via do seu boleto para pagar agora.
          </Body>
        </ModalBody>
      }
      title="fazer o pagamento"
      mainButtonText="finalizar pagamento"
      onClose={() => {
        pushSellerPFDashboardEvent('fechar', 'modal fazer o pagamento');
        setModalOpen(false);
      }}
      mainButtonMethod={() => {
        pushSellerPFDashboardEvent('finalizar pagamento', 'modal fazer o pagamento');
        const link = `${window.location.origin}${paymentUrl}`;
        window.open(link, '_blank');
        setModalOpen(false);
      }}
    />
  );
}
